import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import Translate, { TranslateProps } from 'client/components/translate';
import 'client/styles/calculation.scss';

const lineShape = PropTypes.shape({
  math: PropTypes.string.isRequired,
  label: TranslateProps,
  isResult: PropTypes.bool,
});

const propTypes = {
  calculations: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    lines: PropTypes.arrayOf(lineShape).isRequired,
  })).isRequired,
};

export default class Calculation extends PureComponent {
  render() {
    const { calculations } = this.props;

    return (
      <div className="calculations">
        {calculations.map((calculation, index) => {
          const first = index === 0;
          const last = index === calculations.length - 1;

          return (
            <div className={cx('calculation', { first, last })} key={calculation.key}>
              {calculation.lines.map(line => (
                <div
                  className={cx('line', { result: line.isResult })}
                  key={line.label ? line.label.path : `${calculation.key}result`}>
                  <div className="math">{line.math}</div>
                  <div className="label">
                    {line.label && <Translate {...line.label} />}
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  }
}

Calculation.propTypes = propTypes;
